
export default function undefinedHelmetString(fn: Function) {
  try {
    return fn();
  } catch (e) {
    return '';
  }
}
